import { STORAGE_KEYS } from '~constants'

const setOAuth2Params = (params: Record<string, unknown>) => {
  localStorage.setItem(STORAGE_KEYS.OAUTH2_PARAMS, JSON.stringify(params))
}

export default setOAuth2Params
